export default "__VITE_ASSET__e3bb8dde__"